import { motion } from 'framer-motion'
import React from 'react'
import { Container } from 'react-bootstrap'
import Footer from '../components/Footer'
import PageWrapper from '../components/PageWrapper'
import PageSeo from '../components/seo/PageSeo'
import SideMenu from '../components/SideMenu'

export default function ChauffeurService() {
    return (
      <motion.div 
      initial={{ y: -150, opacity: 0}}
      animate={{ y:0, opacity: 1}}
      exit={{ opacity: 0 }}>
        <PageSeo h1="Chauffeur Service" />
        <SideMenu pageWrapId={'outer-page-wrapper'} outerContainerId={'inner-page-wrapper'} />
          <PageWrapper name={'Chauffeur'} display={<h1 className="txt-big">Chauffeur Service</h1>}>
            <span className="txt-cream txt-shadow">Private driver service across Discovery Bay, Montego Bay, Ocho Rios, and Negril.</span>
          </PageWrapper>
          <Container className="text-cream mb-5" style={{ maxWidth: '70ch' }}>
            <p>
              Sit back while a Reggae Wheels chauffeur handles north-coast driving — airport runs, dinner transfers,
              and full-day itineraries between major towns.
            </p>
            <p>
              Share your route and schedule via About Us and we&apos;ll follow up to arrange your trip.
            </p>
          </Container>
          <Footer></Footer>
      </motion.div>
      )
}
